import { createContext } from 'react';

export const HomepageContext = createContext({});
